import React, { useEffect, useState } from "react";
import { MapContainer, Polygon, Rectangle, TileLayer } from "react-leaflet";
import { CRS, LatLngBounds } from "leaflet";
import PlayerMarker from "./icons/PlayerMarker";
import { coreDataStore } from "../../helper/CoreDataStorage";
import CenterPositionButton from "./icons/CenterPositionButton";
import { Warp } from "../../types/Warps";
import RideMarker from "./icons/RideMarker";
import ShopMarker from "./icons/ShopMarker";
interface Props {
  data: any;
}
const MAP_CENTER_X = 0;
const MAP_CENTER_Z = -200;
const HALF_MAP_SIZE = 300;
const SCALE = 0.426;
const MapSection: React.FC<Props> = ({ data }) => {
  const [warps, setWarps] = useState(coreDataStore.core_data?.warps ?? []);
  const [players, setPlayers] = useState(
    coreDataStore.core_data?.players ?? [],
  );
  useEffect(() => {
    const interval = setInterval(() => {
      setPlayers(coreDataStore.core_data?.players ?? []);
      setWarps(coreDataStore.core_data?.warps ?? []);
    }, 100); // 10 Hz
    return () => clearInterval(interval);
  }, []);
  const targetPlayer = players.find((p: any) => p.uuid === data.uuid);
  return (
    <div className="w-full h-[80%] border border-gray-700 rounded-xl overflow-hidden">
      <MapContainer
        crs={CRS.Simple}
        center={[0, 0]}
        zoom={1}
        minZoom={1}
        maxZoom={3}
        zoomControl={false}
        style={{ width: "100%", height: "100%" }}
        maxBoundsViscosity={1.0}
        attributionControl={false}
      >
        <TileLayer
          url="https://experience.playfinity.net/files/map/{z}/{x}_{y}.png"
          tileSize={256}
          noWrap={false}
        />
        {players.map((p: any) => (
          <PlayerMarker
            key={p.uuid}
            x={mcToLeaflet(p.x, p.z).x}
            y={mcToLeaflet(p.x, p.z).y}
            uuid={p.uuid}
            name={p.name}
          />
        ))}
        {warps
          .filter((warp: Warp) => warp.type === "ride")
          .map((ride: Warp) => (
            <RideMarker
              key={ride.name}
              ride_data={ride}
              x={mcToLeaflet(ride.pos_x, ride.pos_z).x}
              y={mcToLeaflet(ride.pos_x, ride.pos_z).y}
            />
          ))}

        {warps
          .filter((warp: Warp) => warp.type === "shop")
          .map((shop: Warp) => (
            <ShopMarker
              key={shop.name}
              shop_data={shop}
              x={mcToLeaflet(shop.pos_x, shop.pos_z).x}
              y={mcToLeaflet(shop.pos_x, shop.pos_z).y}
            />
          ))}
        <CenterPositionButton
          x={mcToLeaflet(targetPlayer?.x ?? 0, targetPlayer?.z ?? 0).x}
          y={mcToLeaflet(targetPlayer?.x ?? 0, targetPlayer?.z ?? 0).y}
        />
      </MapContainer>
    </div>
  );
};
function mcToLeaflet(x: number, z: number) {
  return {
    x: (x - MAP_CENTER_X) * SCALE,
    y: (z - MAP_CENTER_Z) * SCALE * -1,
  };
}
export default MapSection;
